<template>
  <div class="main-inner-blk">
    <div class="trip-history-container">
      <div class="trip-filter-block">
        <Filters
          :placeHolder="'Search ID/Crew Name/Crew ID/Mobile/Flight No'"
          ref="filters"
          :filterData="'trips'"
          @get-filter="getFilters"
          :dateRange="tripStatus !== 'ongoing' ? true : false"
        ></Filters>
      </div>
      <div class="trip-list-blk" ref="tripList" v-if="tripList.length > 0">
        <div>
          <!-- v-if="tripList.length > 0" -->
          <div class="trip-list-header-blk">
            <!-- <span class="sl-no-blk header-content-blk">Sl No</span> -->
            <span class="id-blk header-content-blk"> Trip ID</span>
            <span class="user-blk header-content-blk" v-if="!$isIndigo">User</span>
            <!-- <span class="corporate-blk header-content-blk" v-if="!$isIndigo">Corporate</span> -->
            <span class="header-content-blk location-blk" v-if="!$isIndigo">Source</span>
            <span class="header-content-blk location-blk" v-if="!$isIndigo">Destination</span>
            <span class="time-blk header-content-blk" v-if="!$isIndigo">PickUp</span>
            <span class="category-blk header-content-blk" v-if="!$isIndigo">Category</span>
            <div class="header-content-blk row-list-blk">
              <div class="row-list">
                <span class="row-list-header">Crew Details</span>
                <span class="row-list-header">Pickup Address</span>
                <span class="row-list-header">Drop Address</span>
                <span class="row-list-header">Drop Off Time</span>
                <span class="row-list-header">Reporting Time</span>
                <span class="row-list-header">SI Comment</span>
              </div>
            </div>
            <!-- <span class="driver-blk header-content-blk">Travelled Details</span> -->
            <span class="driver-blk header-content-blk">Driver</span>
            <!-- <span class="header-content-blk time-blk" v-if="$isIndigo && [0, 1].includes(tripType)">Status</span> -->
            <!-- <div class="action-blk">Actions</div> -->
          </div>

          <div class="trip-content-blk" v-for="(data, index) in tripList" :key="index">
            <div class="id-blk list-content-blk id-content-blk">
              <strong @click="showDetails(data.bigId)" :class="{ 'bigid-blk': !data.id }">{{ data.id ? data.id : data.bigId }}</strong>
              <span v-if="[1, 2].includes(data.serviceType)">{{ data.serviceType === 1 ? "Pickup" : "DropOff" }}</span>
            </div>
            <div class="user-blk content-blk list-content-blk" v-if="!$isIndigo">
              <ul class="assign-employee-list" v-if="[1, 2].includes(data.serviceType)">
                <li v-for="(item, employeeIndex) in data.employees" :key="employeeIndex">
                  <span>{{ item.name }} <span v-if="item.gender">( <strong>{{ item.gender }}</strong> )</span> - {{ item.mobile }}</span><br />
                  <strong v-if="item.crewId">Crew ID: {{ item.crewId }}</strong
                  ><br />
                  <strong style="color: #000099" v-if="item.flightInfo"> {{ checkFlightInfo(item) }}</strong
                  ><br />
                  <strong style="color: #000099" v-if="item.flightInfo"> {{ checkFlightDateAndTime(item) }}</strong>
                  <div></div>
                </li>
              </ul>

              <div v-else>
                <span>{{ data.user }} <span v-if="data.gender">( <strong>{{ data.gender }}</strong> )</span> </span><br />
                <span class="">{{ data.mobile }}</span>
              </div>
            </div>

            <div class="content-blk list-content-blk location-blk" v-if="!$isIndigo">
              <span>{{ data.source }}</span>
            </div>
            <div class="content-blk list-content-blk location-blk" v-if="!$isIndigo">
              <span>{{ data.destination }}</span>
            </div>
            <div class="time-blk content-blk list-content-blk" v-if="!$isIndigo">
              <span>{{ getTime(data.pickUpTime, "pick") }}</span>
              <span>{{ getTimer(data.pickUpTime, "pick") }}</span>
            </div>
            <div class="time-blk content-blk list-content-blk" v-if="!$isIndigo">
              <span v-if="data.serviceType === 1">{{ getTime(data.reportingTime, "drop") }}</span>
              <span v-if="data.serviceType === 1">{{ getTimer(data.reportingTime, "drop") }}</span>
              <span v-else> - </span>
            </div>
            <div class="time-blk content-blk list-content-blk" v-if="!$isIndigo">
              <span v-if="data.reportingTime">{{ getTime(data.reportingTime, "reporting") }}</span>
              <span v-if="data.reportingTime">{{ getTimer(data.reportingTime, "reporting") }}</span>
            </div>

            <div class="content-blk list-content-blk row-list-blk" v-if="$isIndigo">
              <div class="row-list" v-for="(employee, rowIndex) in data.employees" :key="rowIndex">
                <div class="crew-blk">
                  <span>
                    <span>{{ employee.name }} <span v-if="employee.gender">( <strong>{{ employee.gender }}</strong> )</span> - {{ employee.mobile }}</span><br />
                    <strong v-if="employee.crewId">Crew ID: {{ employee.crewId }}</strong
                    ><br />
                    <strong style="color: #000099" v-if="employee.flightInfo"> {{ checkFlightInfo(employee) }}</strong><br />
                    <strong style="color: #000099" v-if="employee.flightInfo">{{ checkFlightDateAndTime(employee) }}</strong>
                  </span>
                </div>
                <div class="crew-blk">{{ ` ${data.serviceType === 1 ? employee.address : data.source}` }}</div>
                <div class="crew-blk">{{ `${data.serviceType === 1 ? data.destination : employee.address}` }}</div>
                <!-- <div class="crew-blk">{{ data.serviceType === 1 ? `${getTime(data.reportingTime, "drop")} ${getTimer(data.reportingTime, "drop")}` : "---" }}</div>
              <div class="crew-blk">{{ `${getTime(data.reportingTime, "reporting")} ${getTimer(data.reportingTime, "reporting")}` }}</div> -->

                <div class="crew-blk">
                  {{
                    data.serviceType === 1
                      ? `${getFormattedDateTime(employee.reportingTime, "drop")}
                `
                      : "---"
                  }}
                </div>
                <div class="crew-blk">{{ `${getFormattedDateTime(employee.reportingTime, "reporting")} ` }}</div>

                <div class="crew-blk">{{ employee.siComment ? employee.siComment : "---" }}</div>
              </div>
            </div>

            <!-- <div class="driver-blk list-content-blk">sample</div> -->
            <div class="driver-blk list-content-blk">
              <span v-if="data.driverDetails !== null">{{ data.driverDetails.name }} - {{ data.driverDetails.mobile }} - {{ data.vehicle }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="no-trip-list" v-else>
        <span>No Trips Available</span>
      </div>

      <div class="pagination">
        <!-- <v-pagination v-model="page" :length="1" :total-visible="4" @click="loadmore"></v-pagination> -->
        <v-pagination v-if="pageCount > 0" v-model="page" :length="Math.ceil(pageCount / 20)" @input="getTrips(filters)" :total-visible="6"></v-pagination>
      </div>
    </div>

    <v-navigation-drawer v-model="drawer" temporary width="1200" absolute>
      <TripDetails @closeTripDetails="handleDrawerClose" :tripId="tripId" v-if="drawer"></TripDetails>
    </v-navigation-drawer>
  </div>
</template>

<script>
import Filters from "../../common/filter/Filters.vue";
import axios from "@/axios/axios-global";
import TripDetails from "../trip-details/TripDetails.vue";
import moment from "moment";
export default {
  name: "TripHistory",
  components: { Filters, TripDetails },
  props: {
    tripStatus: String,
  },
  data() {
    return {
      filters: { searchQuery: "", start: moment().format("YYYY-MM-DD"), end: moment().format("YYYY-MM-DD") },
      page: 1,

      tripList: [],

      drawer: false,
      tripId: 0,
    };
  },
  mounted() {
    this.getTrips({ searchQuery: "", start: moment().format("YYYY-MM-DD"), end: moment().format("YYYY-MM-DD") });
  },
  methods: {
    getFilters(filter) {
      this.filters = filter;
      this.page = 1;
      this.getTrips(this.filters);
      // this.$emit("get-all-filters", this.filters);
    },
    async getTrips(filter) {
      const payload = filter;
      console.log(payload, "payload-----------------");
      payload["page"] = this.page;
      payload["limit"] = 20;
      payload["startDate"] = filter.start;
      payload["endDate"] = filter.end;
      payload["isEnded"] = this.tripStatus === "ongoing" ? false : true;
      const response = await axios.post("trip/filter", payload);
      if (response.status == 200) {
        this.tripList = response.data.list;
        this.pageCount = response.data.total;
      }
    },
    checkFlightInfo(item) {
      return item.flightInfo.replace(/.*Flight No:(\S+)(?:.*?at (\S+) from (\S+)|.*?from (\S+) to (\S+))/, (_, flightNo, at1, from1, from2, to2) => {
        if (at1 && from1) return `${flightNo} ${at1} - ${from1}`;
        if (from2 && to2) return `${flightNo} ${from2} - ${to2}`;
        return flightNo; // fallback in case no match
      });
    },
    checkFlightDateAndTime(item) {
      const match = item.flightInfo.match(/\d{4}-\d{2}-\d{2} \d{2}:\d{2}/);
      if (match) {
        const dateTimeStr = match[0]; // "2025-06-07 11:50"
        const [date, time] = dateTimeStr.split(" ");
        return `${date} ${time}`;
      } else {
        return null;
      }
    },
    getDateAndTime(date, format) {
      return date ? moment(date, format).format("DD-MM-YYYY HH:mm") : "";
    },

    getFormattedDateTime(data, type) {
      let dateTime = moment(data);

      if (type === "drop") {
        dateTime = dateTime.subtract(20, "minutes");
      }

      return dateTime.format("MMM DD HH:mm");
    },

    getTime(data, type) {
      if (type !== "drop") return moment(data, "x").format("MMM DD");
      else return moment(data, "x").subtract("20", "minutes").format("MMM DD");
    },
    getTimer(data, type) {
      if (type !== "drop") return moment(data, "x").format("HH:mm");
      else return moment(data, "x").subtract("20", "minutes").format("HH:mm");
    },
    showDetails(data) {
      this.drawer = true;
      this.tripId = data;
    },
    handleDrawerClose() {
      this.drawer = false;
      this.tripId = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.assign-filter-blk {
  padding: 20px;
  background-color: white;
  width: 100%;
  border-radius: 5px;
  display: flex;
  align-items: center;
}

.trip-filter-block {
  padding: 10px;
}

.trip-list-blk {
  background-color: white;
  padding-top: 20px;
  width: 100%;
  border-radius: 5px;
  height: calc(100vh - 260px);
  overflow-y: auto;
  margin-top: 20px;

  .trip-list-header-blk {
    margin: 0 20px 0 20px;
    position: sticky;
    top: -20px;
    background-color: white;
    border: 1px solid #d6d6d6;
    border-radius: 0;
    display: flex;
    //   font-weight: bold;
    color: #6a0737;
    z-index: 1;
    font-size: 0.75rem;

    .header-content-blk {
      // padding: 10px;
      border-right: 1px solid #d6d6d6;
      text-align: center;
      &:last-child {
        border-right: none;
      }
    }
    span {
      padding: 10px;
    }
  }
  .cancellation-block {
    .header-content-blk,
    .list-content-blk {
      // flex: 1;
      text-align: center;
      &:last-child {
        border-right: none;
      }
    }

    .row-list-blk {
      width: 95%;
    }

    .sl-no-blk {
      width: 5%;
      flex: 0 1 auto;
    }
  }

  .no-trip-blk {
    text-align: center;
    margin-top: auto;
    margin-bottom: auto;

    span {
      color: #d6d6d6;
      font-size: 14px;
      font-weight: bold;
    }
  }

  .trip-content-blk {
    display: flex;
    border: 1px solid #d6d6d6;
    border-top: none;
    margin: 0 20px 0 20px;

    .list-content-blk {
      // padding: 5px;
      border-right: 1px solid #d6d6d6;
      text-align: center;

      &:last-child {
        border-right: none;
      }
      .source-blk {
        font-size: 12px;
        color: #b02604;
        font-weight: bold;
        //white-space: nowrap;
        //overflow: hidden;
        //text-overflow: ellipsis;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }

    .content-blk {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
}

.no-trip-list {
  height: calc(100vh - 240px);
  display: flex;
  justify-content: center;
  align-items: center;
}

.sl-no-blk {
  width: 5%;
  display: flex;
  align-items: center;
}

.id-blk,
.location-blk,
.user-blk,
.time-blk,
.corporate-blk,
.driver-blk,
.whatsapp-blk {
  padding: 10px;
}

.id-blk {
  width: 8%;
}

.location-blk {
  width: 14%;
}

.id-content-blk {
  width: 8%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  span,
  strong {
    font-size: 13px;
  }
  strong {
    width: 100%;
    cursor: pointer;
    color: #2279ea;
    word-break: break-word;
  }

  .bigid-blk {
    color: #2444a1;
  }
}

.user-blk {
  width: 13%;
}

.row-list-blk {
  width: 95%;

  // display: flex;
  // flex-direction: row;
  .row-list {
    display: flex;

    height: 100%;
    border-bottom: 1px solid #d6d6d6;
    &:last-child {
      border-bottom: none;
    }

    .row-list-header {
      flex: 1;
      border-right: 1px solid #d6d6d6;
      height: 100%;
      &:last-child {
        border-right: none;
      }
    }
  }
  .crew-blk {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 5px;
    word-break: break-word;
    overflow-wrap: break-word;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #d6d6d6;
    height: 100%;
    padding: 5px;
    &:last-child {
      border-right: none;
    }
  }
}

.corporate-blk {
  width: 8%;
  .marshal-row {
    color: #600a0a;
    font-weight: bold;
    margin: 5px 0;
  }
}

.time-blk {
  width: 7%;
  &:last-child {
    border-right: none !important;
  }
}

.category-blk {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 7%;
}

.details-blk {
  width: 20%;

  span {
    margin: 5px 0;
  }

  //  .details-button-blk {
  //   .v-btn:not(.v-btn--round).v-size--x-small {
  //    height: 30px;
  //   }
  //  }
}

.driver-blk {
  width: 15%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  //  flex-direction: column;
  //  justify-content: center;
  gap: 10px;
  //  justify-content: space-between;
  //  align-items: center;
  border-right: 1px solid #d6d6d6;
  padding: 5px 10px;

  .driver-action-blk {
    width: 100%;
    text-align: center;
    .details-button-blk {
      margin-top: 10px;
    }
  }

  //  &:last-child {
  //   border-right: none;
  //  }
  ::v-deep .v-btn {
    //   font-weight: bold;
    color: white;
  }
  ::v-deep .v-text-field {
    font-size: 13px;
    margin-bottom: 10px;
  }
  ::v-deep .v-label {
    font-size: 13px;
  }
}

.reject-blk {
  width: 5%;
  border-right: 1px solid #d6d6d6;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .v-btn {
    font-size: 15px;
  }

  .whatsapp-blk {
    font-size: 25px;
  }
}
.action-blk {
  // width: 7%;
  border-right: none;
  min-width: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.card-view-modal {
  padding: 15px;
  span {
    font-weight: bold;
  }
  .card-button-blk {
    display: flex;
    flex-direction: row-reverse;
  }
}
.v-dialog > .v-card > .v-card__actions {
  display: flex;
  justify-content: flex-end;
}

.trash {
  background: red;
}
</style>
